import { Component, OnInit, Output, EventEmitter } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { AccountService } from '../account.service';
import { debounceTime, distinctUntilChanged, filter, flatMap, delay} from 'rxjs/operators';
import { Device } from '../models/kiosk';
import { MatSnackBar } from '@angular/material/snack-bar';

@Component({
  selector: 'app-add-account',
  templateUrl: './add-account.component.html',
  styleUrls: ['./add-account.component.css'],
})
export class AddAccountComponent implements OnInit {
  @Output() emitDevice: EventEmitter<Device> = new EventEmitter<Device>();
  formGroup: FormGroup;
  loading = false;

  constructor(
    private _fb: FormBuilder,
    private _accountService: AccountService,
    public snackBar: MatSnackBar
  ) {}

  ngOnInit() {
    this.createForm();
  }

  createForm(): any {
    this.formGroup = this._fb.group({
      email: ['', Validators.pattern('[A-Za-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,3}$')],
      first_name: ['', Validators.required],
      last_name: ['', Validators.required]
    });
  }

  saveAccount() {
    this.loading = true;
    this._accountService.createAccountWithoutPassword(this.formGroup.value).subscribe((data) => {
      this.loading = false;
      console.log(data);
      this.snackBar.open('Success');
      this.formGroup.reset();
    }, (error) => {
      this.loading = false;
      console.error(error);
      this.snackBar.open(error.error.type, '', { duration: 1250 });
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/add-account/add-account.component.ts